<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-btn icon to="/courier">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>Mis Paquetes</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/help">
        <v-icon>flaticon-information</v-icon>
      </v-btn>
      <v-btn v-if="showDelivery == true" icon to="/delivery">
        <v-icon>flaticon-food</v-icon>
      </v-btn>
      <v-btn icon to="/invoice">
        <v-icon>flaticon-clock-1</v-icon>
      </v-btn>
    </v-app-bar>

    <div class="new-list-of-packages" v-if="items.length > 0">
      <v-tabs centered color="#005F86" class="mt-3">
        <v-tab @click="changeList(1)">Mis Paquetes</v-tab>
        <!-- <v-tab @click="changeList(2)">Historial</v-tab> -->
      </v-tabs>
      <v-list three-line>
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <v-list-item-content>
              <div class="new-list-of-packages__item-content">
                <div class="new-list-of-packages__genearl-info">
                  <v-list-item-title
                    :class="item.colorestatus+'-text new-list-of-packages__title'"
                    v-html="item.contenido"
                  ></v-list-item-title>
                  <div class="detail__text font-weight-black">
                    Estatus {{item.desc_estatus_proceso
                    }}
                  </div>
                  <div class="detail__text">Recibido el {{item.fec_creacion}}</div>
                  <div class="detail__text">Tracking No. {{item.tracking_number}}</div>
                  <div class="detail__text">Guia No.{{item.guia}}</div>
                  <div class="mt-2">
                    <v-progress-linear
                      :color="item.colorestatus"
                      height="10"
                      v-model="item.trackingestatus"
                    ></v-progress-linear>
                  </div>
                </div>
                <div class="new-list-of-packages__important-info">
                  <div>
                    <div>
                      Pesa
                      <br />
                      {{ item.peso + " " + ((item.peso > 1) ? " Libras" : " Libra") }}
                    </div>
                    <div v-if="item.totalpagar">
                      Total a pagar
                      <br />
                      {{ "RD$ " + item.totalpagar }}
                    </div>
                  </div>

                  <div v-if="item.mostrar_boton == 0">
                    <v-btn
                      :loading="loading"
                      :disabled="loading"
                      small
                      color="primary"
                      class
                      @click="pickFile(item.guia,item.id_)"
                    >
                      Subir
                      <br />Factura
                      <!-- <v-icon right dark>cloud_upload</v-icon> -->
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{language.you_have_no_data_available}}
        </div>
      </div>
      <v-progress-circular :size="90" color="blue" indeterminate class="loading-center" v-else></v-progress-circular>
    </div>

    <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
// import { mapState } from "vuex";
var files = [];
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
            // this.getPacksHistory();
          }
        }
      }
    );
    this.$store.watch(
      (state, getters) => getters.profile,
      // (newValue, oldValue) => {
      () => {
        this.showDeliveryFc();
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
      // this.getPacksHistory();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
      // this.getPacksHistory();
    }

    this.showDeliveryFc();
  },
  data() {
    return {
      clipped: false,
      items: [],
      packs: [],
      history: [],
      currentUser: undefined,
      noData: false,
      loading: false,
      imageFile: null,
      imageName: "",
      guia: null,
      idpack: null,
      showDelivery: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    profile: function () {
      return this.$store.getters.profile;
    },
    status: function () {
      return this.$store.getters.status;
    },
  },
  methods: {
    changeList(data) {
      // if (this.history.length === 0) {
      //   this.getPacksHistory();
      // }
      if (data == 1) {
        this.items = this.packs;
      } else {
        this.items = this.history;
      }
    },
    showDeliveryFc() {
      if (this.profile.length > 0) {
        if (
          this.profile[0].domicilio != "" &&
          this.profile[0].domicilio != 0 &&
          this.profile[0].domicilio != "0" &&
          this.profile[0].domicilio != undefined
        ) {
          this.showDelivery = true;
        } else {
          this.showDelivery = false;
        }
      } else {
        this.showDelivery = false;
      }
    },
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoice,
        guia,
        idpack,
        this.currentUser.userName,
        this.getPacks
      );
    },
    onFilePicked() {
      this.loading = true;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          var formData = new FormData();
          formData.append("text1", this.currentUser.userName);
          formData.append("text3", this.currentUser.pushId);
          formData.append("device", window.MobileApi.device);
          formData.append("PARAMETRO2", this.guia);
          formData.append("PARAMETRO1", this.idpack);
          formData.append("photo", this.imageFile);
          this.$http.post(Server.uploadInvoice, formData).then(
            // response => {
            () => {
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        });
      }
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      var _store = this.$store;
      this.$http.post(Server.packs, formData).then(
        (response) => {
          console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.items = response.body;
            this.packs = response.body;
            _store.dispatch("setStatus", response.body);
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
    getPacksHistory() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      var _store = this.$store;
      this.$http.post(Server.history, formData).then(
        (response) => {
          console.log(response.body);
          if (response.body.resultado !== "NO") {
            // this.items = response.body;
            this.history = response.body;
            _store.dispatch("setStatus", response.body);
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
